import { useContext, useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { DataTableContext } from "../../component/datatable/DataTableContext";

const PARAM_NAME = 'ctx';

const useNavigationContext = (onReadParams) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();
    const initialized = useRef(false);

    const ctxRef = useRef([]);
    const encodedCtxRef = useRef(null);

    // Inicjalizacja stanu na podstawie URL lub domyślnych
    useEffect(() => {
        if (!initialized.current) {
            const raw = searchParams.get(PARAM_NAME);
            let newCtx = [];
            let newParams = {};
            if (raw) {
                try {
                    const ctx = deserialize(raw);
                    const viewId = location.pathname;
                    const index = ctx.findIndex(c => c.viewId === viewId);
                    if (index !== -1) {
                        newParams = ctx[index].params;
                        ctx.splice(index);
                    }
                    newCtx = ctx;
                } catch (e) {
                    console.error('Failed to decode Base64 context from URL', e);
                }
            }
            newCtx.push({
                viewId: location.pathname,
                params: newParams
            });
            if (typeof onReadParams === 'function') {
                onReadParams(newParams);
            }
            ctxRef.current = newCtx;
            const encoded = serialize(newCtx);
            encodedCtxRef.current = encoded;
            setSearchParams((prev) => {
                const newParams = new URLSearchParams(prev);
                newParams.set(PARAM_NAME, encoded);
                return newParams;
            }, { replace: true });
            initialized.current = true;
        }
    }, [searchParams, location.pathname]);
    
    const serialize = (ctx) => {
        return btoa(encodeURIComponent(JSON.stringify(ctx)));
    }

    const deserialize = (encoded) => {
        function isDateString(str) {
            return typeof str === 'string' && (
                /^\d{4}-\d{2}-\d{2}$/.test(str) ||
                /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(str)
            );
        }
        return JSON.parse(
            decodeURIComponent(atob(encoded)), (key, value) => isDateString(value) ? new Date(value) : value);
    }

    return {
        getContextParam: () => {
            if (!encodedCtxRef.current) {
                return '';
            }
            return PARAM_NAME + '=' + encodedCtxRef.current;
        },
        putParam: (name, value) => {
            if (initialized.current) {
                try {
                    if (ctxRef.current) {
                        const ctx = ctxRef.current;
                        const view = ctx.find(item => item.viewId === location.pathname);
                        if (view) {
                            if (!view.params) {
                                view.params = {};
                            }
                            view.params[name] = value;
                        }
                        const encoded = serialize(ctx);
                        setSearchParams((prev) => {
                            const newParams = new URLSearchParams(prev);
                            newParams.set(PARAM_NAME, encoded);
                            return newParams;
                        }, { replace: true });
                        encodedCtxRef.current = encoded;
                    }
                } catch (e) {
                    console.error('Failed to encode context to Base64', e);
                }
            }

        }
    };
}

export default useNavigationContext;